import httpClient from "./httpClient";

export async function listLikedCoupons() {
  const { data } = await httpClient.get("/users/me/liked-coupons");
  return data.coupons || [];
}

export async function addLikedCoupon(couponPublicId) {
  const { data } = await httpClient.post(
    `/users/me/liked-coupons/${encodeURIComponent(couponPublicId)}`
  );
  return data;
}

export async function removeLikedCoupon(couponPublicId) {
  const { data } = await httpClient.delete(
    `/users/me/liked-coupons/${encodeURIComponent(couponPublicId)}`
  );
  return data;
}
